// Quicklink implementation for Shopify
(function() {
  // Debug flag
  const DEBUG = false;
  
  function log(...args) {
    if (DEBUG) console.log('[Quicklink]', ...args);
  }

  // Don't run if the browser doesn't support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    log('IntersectionObserver not supported, disabling Quicklink');
    return;
  }

  // Wait for both the DOM and window load
  function initialize() {
    if (!window.quicklink) {
      log('Quicklink library not loaded yet, waiting...');
      return;
    }

    log('Initializing Quicklink...');

    // Configure Quicklink
    window.quicklink.listen({
      // Specify origins to prefetch (including current origin)
      origins: [
        location.hostname,
        // Add any other domains you want to allow prefetching for
      ],
      
      // Debug callback
      onError: (error) => {
        log('Prefetch error:', error);
      },
      
      // Ignore patterns for Shopify-specific routes and dynamic content
      ignores: [
        // Debug which URLs are being ignored
        (uri) => {
          // Convert URI to lowercase for case-insensitive matching
          const lowerUri = uri.toLowerCase();
          
          // Protected routes that should never be prefetched
          const protectedRoutes = [
            '/cart',
            '/account',
            '/challenge',
            '/orders',
            '/checkouts',
            '/admin',
            '/password',
            '/addresses',
            '/customer_authentication',
            '?_fd=',
            '?pb=',
            '/cdn/',
          ];

          // Check if URL contains any protected routes
          const isProtected = protectedRoutes.some(route => 
            lowerUri.includes(route.toLowerCase())
          );

          if (isProtected) {
            log('Ignoring protected URL:', uri);
            return true;
          }

          // Ignore asset files
          const assetExtensions = ['.js', '.css', '.png', '.jpg', '.jpeg', '.gif', '.webp'];
          const isAsset = assetExtensions.some(ext => 
            lowerUri.endsWith(ext.toLowerCase())
          );

          if (isAsset) {
            log('Ignoring asset URL:', uri);
            return true;
          }

          // Ignore hash links only if they're internal page anchors
          if (uri.includes('#') && uri.split('#')[0] === location.pathname) {
            log('Ignoring internal anchor URL:', uri);
            return true;
          }

          // Allow prefetching for product and collection pages
          const allowedRoutes = [
            '/products/',
            '/collections/',
            '/pages/',
            '/blogs/'
          ];

          const isAllowed = allowedRoutes.some(route => 
            lowerUri.includes(route.toLowerCase())
          );

          if (isAllowed) {
            log('Allowing prefetch for:', uri);
            return false;
          }

          // If not explicitly allowed, ignore by default
          log('Ignoring URL by default:', uri);
          return true;
        },
        // Ignore if data-no-prefetch attribute exists
        (uri, elem) => {
          const hasNoPrefetch = elem.hasAttribute('data-no-prefetch');
          if (hasNoPrefetch && DEBUG) {
            log('Ignoring element with data-no-prefetch:', elem);
          }
          return hasNoPrefetch;
        },
        // Ignore if data-dynamic-checkout attribute exists (Shopify checkout buttons)
        (uri, elem) => {
          const hasDynamicCheckout = elem.hasAttribute('data-dynamic-checkout');
          if (hasDynamicCheckout && DEBUG) {
            log('Ignoring dynamic checkout button:', elem);
          }
          return hasDynamicCheckout;
        }
      ],
      
      // Timeout (in milliseconds) after which prefetching will occur
      timeout: 2000,
      
      // Maximum number of concurrent prefetches
      limit: 2,
      
      // Use low priority prefetching by default
      priority: false,

      // Only prefetch links that are in the viewport
      el: document.documentElement
    });

    log('Quicklink initialized successfully');
  }

  // Try to initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Also try to initialize when window loads (backup)
  window.addEventListener('load', initialize);
})(); 